import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { cn } from "@client/utils/cn";

export const RoundPage = withErrorBoundary(
  ({
    className,
    title,
    description,
    cta,
    fullWidth = false,
    children,
  }: {
    className?: string;
    title: string;
    description?: string;
    cta?: React.ReactNode;
    /**
     * Pages dominated by a wide table (Onboarding, Investigations, Recusals)
     * skip the max-w-content cap so the table can use the whole viewport
     * before falling back to scrolling inside its box.
     */
    fullWidth?: boolean;
    children?: React.ReactNode;
  }) => (
    <div
      className={cn(
        "relative min-h-full p-4 flex mx-auto w-full gap-6 flex-col",
        !fullWidth && "max-w-content",
      )}
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <header>
          <h1 className="text-2xl font-bold">{title}</h1>
          {description && (
            <p className="text-xs text-muted-foreground">{description}</p>
          )}
        </header>
        {cta}
      </div>
      <div className={cn("flex-1", className)}>{children}</div>
    </div>
  ),
);
